// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-refer-a-friend-js": () => import("./../../../src/pages/refer-a-friend.js" /* webpackChunkName: "component---src-pages-refer-a-friend-js" */),
  "component---src-pages-special-classes-online-js": () => import("./../../../src/pages/special-classes-online.js" /* webpackChunkName: "component---src-pages-special-classes-online-js" */)
}

